import { useCombobox } from 'downshift';
import { useState } from 'react';
import type { CommandPaletteSearchResult } from '../../../../shared/CommandPalette/types';
import { useReplacePath } from '../../../contexts/RouterContext';
import useFilteredResults from './useFilteredResults';

/**
 * Set up the command palette search functionality using downshift.
 */
function useCommandPalette(onHide: () => void) {
  const replacePath = useReplacePath();
  const [searchQuery, setSearchQuery] = useState<string>('');
  const filteredResults = useFilteredResults(searchQuery);

  const {
    highlightedIndex,
    getInputProps,
    getMenuProps,
    getItemProps,
    selectItem,
  } = useCombobox<CommandPaletteSearchResult>({
    items: filteredResults,
    itemToString: (item) => item?.label ?? '',
    onSelectedItemChange: ({ selectedItem }) => {
      if (selectedItem?.to) {
        replacePath(selectedItem.to);
        onHide();
      }
    },
    onInputValueChange: ({ inputValue: search }) => {
      const searchToLowerCase = search.trim().toLowerCase();
      setSearchQuery(searchToLowerCase);
    },
  });

  return {
    items: filteredResults,
    hasNoResults: filteredResults.length === 0,
    searchQuery,
    highlightedIndex,
    getInputProps: () => {
      return getInputProps({
        onKeyDown: (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            const firstItem = filteredResults[0];
            if (firstItem) {
              selectItem(firstItem);
            }
          }
        },
      });
    },
    getMenuProps,
    getItemProps,
  };
}

export default useCommandPalette;
